// ─── RESOURCES INDEX PAGE ─────────────────────────────────────────────────────
// Save this file as src/resources/index.tsx
// Then create src/resources/FloridaSirsRequirements2026.tsx
// and src/resources/HowToReadSirsReport.tsx (see below)

import React from 'react';
import { Link } from 'react-router-dom';

const C = {
  navy:     '#1B3A5C',
  navyDark: '#122840',
  teal:     '#2A9D8F',
  white:    '#FFFFFF',
  offWhite: '#F7F9FC',
  slate:    '#64748B',
  slateLight: '#94A3B8',
  border:   '#E2E8F0',
};

const Navbar = () => (
  <nav style={{ position: 'sticky', top: 0, zIndex: 100, background: C.navyDark, borderBottom: `2px solid ${C.teal}`, padding: '0 32px' }}>
    <div style={{ maxWidth: 1100, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 68 }}>
      <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 12, textDecoration: 'none' }}>
        <img src="/logo.png" alt="FloridaSIRS" style={{ height: 44 }} />
        <span style={{ fontFamily: 'Georgia, serif', fontSize: 20, fontWeight: 700, color: C.white }}>
          FloridaSIRS<span style={{ color: C.teal }}>.org</span>
        </span>
      </Link>
      <div style={{ display: 'flex', gap: 28, alignItems: 'center' }}>
        <Link to="/resources" style={{ color: C.slateLight, textDecoration: 'none', fontSize: 15 }}>Resources</Link>
        <Link to="/app" style={{ background: C.teal, color: C.white, padding: '10px 22px', borderRadius: 4, fontSize: 15, fontWeight: 600, textDecoration: 'none' }}>Open App →</Link>
      </div>
    </div>
  </nav>
);

const Footer = () => (
  <footer style={{ background: C.navyDark, padding: '32px 24px', borderTop: `2px solid ${C.teal}` }}>
    <div style={{ maxWidth: 1100, margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 16 }}>
      <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.35)' }}>© {new Date().getFullYear()} FloridaSIRS.org. Not affiliated with DBPR. Not legal or financial advice.</p>
      <div style={{ display: 'flex', gap: 24 }}>
        <Link to="/" style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)', textDecoration: 'none' }}>Home</Link>
        <Link to="/resources" style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)', textDecoration: 'none' }}>Resources</Link>
        <Link to="/privacy" style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)', textDecoration: 'none' }}>Privacy</Link>
        <Link to="/app" style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)', textDecoration: 'none' }}>Open App</Link>
      </div>
    </div>
  </footer>
);

export { Navbar, Footer, C };

const articles = [
  {
    slug: 'florida-sirs-requirements-2026',
    title: 'Florida SIRS Requirements 2026 — The Complete Guide for Condo Boards',
    description: 'Everything Florida condo boards need to know about HB 913 SIRS requirements — the 8 mandatory components, baseline funding plan rules, DBPR reporting deadlines, and what happens if your association is non-compliant.',
    tag: 'Compliance Guide',
    readTime: '14 min read',
    date: 'March 2026',
  },
  {
    slug: 'how-to-read-a-sirs-report',
    title: 'How to Read a SIRS Report — A Plain-English Guide for Florida Condo Boards',
    description: 'Your engineer delivered a 35-page SIRS report. This guide walks through every section — what the numbers mean, what to look for, questions to ask your engineer, and how to turn the report into an HB 913 baseline funding plan.',
    tag: 'Board Education',
    readTime: '12 min read',
    date: 'March 2026',
  },
];

export default function ResourcesIndex() {
  return (
    <>
      <style>{`*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; } body { font-family: 'DM Sans', 'Helvetica Neue', sans-serif; background: ${C.white}; color: ${C.navy}; }`}</style>
      <Navbar />
      <div style={{ background: C.navy, padding: '64px 24px' }}>
        <div style={{ maxWidth: 800, margin: '0 auto' }}>
          <p style={{ fontSize: 13, fontWeight: 700, color: C.teal, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 12 }}>Resources</p>
          <h1 style={{ fontFamily: 'Georgia, serif', fontSize: 'clamp(28px, 4vw, 42px)', fontWeight: 700, color: C.white, marginBottom: 16 }}>
            Florida SIRS Guides for Condo Boards
          </h1>
          <p style={{ fontSize: 17, color: 'rgba(255,255,255,0.6)', lineHeight: 1.65 }}>
            Plain-English guides to Florida HB 913 SIRS compliance. Written for board members and property managers — no legal jargon.
          </p>
        </div>
      </div>
      <div style={{ background: C.offWhite, padding: '64px 24px 96px' }}>
        <div style={{ maxWidth: 800, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 24 }}>
          {articles.map(({ slug, title, description, tag, readTime, date }) => (
            <Link key={slug} to={`/resources/${slug}`} style={{ textDecoration: 'none' }}>
              <div style={{
                background: C.white, borderRadius: 8, padding: '36px 40px',
                border: `1px solid ${C.border}`, boxShadow: '0 2px 8px rgba(27,58,92,0.05)',
                transition: 'box-shadow 0.2s, transform 0.2s',
              }}
                onMouseEnter={e => { (e.currentTarget as HTMLDivElement).style.boxShadow = '0 8px 32px rgba(27,58,92,0.12)'; (e.currentTarget as HTMLDivElement).style.transform = 'translateY(-2px)'; }}
                onMouseLeave={e => { (e.currentTarget as HTMLDivElement).style.boxShadow = '0 2px 8px rgba(27,58,92,0.05)'; (e.currentTarget as HTMLDivElement).style.transform = 'translateY(0)'; }}
              >
                <div style={{ display: 'flex', gap: 12, marginBottom: 16, alignItems: 'center' }}>
                  <span style={{ background: 'rgba(42,157,143,0.1)', color: C.teal, fontSize: 12, fontWeight: 700, padding: '4px 12px', borderRadius: 100, letterSpacing: '0.05em', textTransform: 'uppercase' }}>{tag}</span>
                  <span style={{ fontSize: 13, color: C.slateLight }}>{readTime}</span>
                  <span style={{ fontSize: 13, color: C.slateLight }}>·</span>
                  <span style={{ fontSize: 13, color: C.slateLight }}>{date}</span>
                </div>
                <h2 style={{ fontFamily: 'Georgia, serif', fontSize: 22, fontWeight: 700, color: C.navy, marginBottom: 12, lineHeight: 1.35 }}>{title}</h2>
                <p style={{ fontSize: 15, color: C.slate, lineHeight: 1.7, marginBottom: 20 }}>{description}</p>
                <span style={{ fontSize: 15, fontWeight: 600, color: C.teal }}>Read guide →</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
}
